import React from "react";

// Ortak "gerçekçi masa" görünümü (üstten görünüm: tabla + sandalyeler + büyük numara).
// Hem Şema Editörü hem Operasyon Panosu bu bileşeni kullanır -> kalıcı görsel parite.
// SC=1.6 ölçek kullanıcının onayladığı değerdir; değiştirmeyin.
const SC = 1.6;

export const RealTable = ({
  number,
  capacity = 4,
  edgeColor,                 // gövde kenar rengi
  bodyBg,                    // gövde arka planı
  bodyBorderStyle = "solid", // 'solid' | 'dashed'
  glow = "0 4px 12px rgba(0,0,0,0.45)",
  numberSize = 18,           // SC ile çarpılır
  sublabel,                  // numara altındaki metin ("4 kişi" veya "2/4")
  sublabelColor,
  // Sandalye dolumu
  fillAllChairs = false,     // Şema: her sandalye dolu
  filledCount = 0,           // Ops: dolu sandalye (oturan) sayısı
  chairFilledColor,          // dolu sandalye rengi
  chairFilledOpacity = 1,
  chairEmptyBorderColor = "#475569",
  chairBorder = true,        // Ops kenarlık çizer; Şema çizmez
  rotation = 0,              // masa döndürme (derece): yazı ters yönde döndürülüp DİK/okunur kalır
}) => {
  const cap = capacity ?? 4; // 0 = kapasite verilmemiş -> en küçük masa (1 çift sandalye) çizilir
  const pairs = Math.max(1, Math.round(cap / 2)); // her kenardaki sandalye sayısı
  const chairW = 26 * SC, chairH = 11 * SC, cgap = 6 * SC;
  const bodyW = pairs * chairW + (pairs - 1) * cgap + 14 * SC;
  const bodyH = 46 * SC;

  const chairRow = (topRow) => (
    <div className="flex justify-center" style={{ gap: cgap }}>
      {Array.from({ length: pairs }).map((_, i) => {
        const idx = topRow ? i * 2 : i * 2 + 1; // sütun-sütun dolum
        const filled = fillAllChairs || idx < filledCount;
        return (
          <div key={i} style={{
            width: chairW, height: chairH,
            borderRadius: topRow ? `${6 * SC}px ${6 * SC}px ${3 * SC}px ${3 * SC}px` : `${3 * SC}px ${3 * SC}px ${6 * SC}px ${6 * SC}px`,
            background: filled ? chairFilledColor : "transparent",
            opacity: filled ? chairFilledOpacity : 1,
            border: chairBorder ? `${1.5 * SC}px solid ${filled ? chairFilledColor : chairEmptyBorderColor}` : undefined,
          }} />
        );
      })}
    </div>
  );

  return (
    <>
      <div style={{ marginBottom: -2 * SC }}>{chairRow(true)}</div>
      <div className="flex items-center justify-center relative" style={{
        width: bodyW, height: bodyH, borderRadius: 9 * SC,
        background: bodyBg,
        border: `${2.5 * SC}px ${bodyBorderStyle} ${edgeColor}`,
        boxShadow: glow,
      }}>
        <div className="flex flex-col items-center justify-center leading-none" style={rotation ? { transform: `rotate(${-rotation}deg)` } : undefined}>
          <span className="font-mono font-black tracking-tight" style={{ fontSize: numberSize * SC, color: "#F1F5F9", textShadow: "0 1px 2px rgba(0,0,0,0.6)" }}>{number}</span>
          <span className="font-mono font-bold" style={{ fontSize: 10 * SC, color: sublabelColor }}>{sublabel}</span>
        </div>
      </div>
      <div style={{ marginTop: -2 * SC }}>{chairRow(false)}</div>
    </>
  );
};

export default RealTable;
